export default class PlayerPopup {
    constructor(selector = '.player') {
        this.players = document.querySelectorAll(selector);
        this.currentPopup = null;

        if (this.players.length) {
            this.bindEvents();
        }
    }

    bindEvents() {
        this.players.forEach((player) => {
            player.addEventListener('click', (e) => {
                e.preventDefault();

                const url = player.dataset.url;
                if (!url) return;

                const isPlaying = this.anyPlayerIsPlaying();

                if (isPlaying) {
                    this.closePopup();
                    this.setAllPlayersPlaying(false);
                    return;
                }

                this.setAllPlayersPlaying(true);
                this.openPopup(url);
            });
        });
    }

    openPopup(url) {
        const width = 300;
        const height = 400;
        const left = (window.innerWidth - width) / 2 + window.screenX;
        const top = (window.innerHeight - height) / 2 + window.screenY;

        this.currentPopup = window.open(
            url,
            'radioPopup',
            `width=${width},height=${height},left=${left},top=${top},resizable=no`
        );

        // Vérifie quand la popup est fermée
        const poll = setInterval(() => {
            if (!this.currentPopup || this.currentPopup.closed) {
                this.setAllPlayersPlaying(false);
                clearInterval(poll);
                this.currentPopup = null;
            }
        }, 300);
    }

    closePopup() {
        if (this.currentPopup && !this.currentPopup.closed) {
            this.currentPopup.close();
            this.currentPopup = null;
        }
    }

    setAllPlayersPlaying(state) {
        this.players.forEach((player) => {
            player.classList.toggle('is-playing', state);
        });
    }

    anyPlayerIsPlaying() {
        return [...this.players].some((player) => player.classList.contains('is-playing'));
    }
}
